import React from "react";

/**
 * CheckCircleIcon — Stepper checkmark icon
 * Figma: check-circle component (I24654:6699;625:7288;625:7233)
 *
 * @param {number} size - Icon size (default 32)
 * @param {string} color - Icon color
 * @param {boolean} active - Whether this is the active/current step
 */
const CheckCircleIcon = ({ size = 32, color = "#737373", active = false }) => {
  const fillColor = active ? "#fafafa" : color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="12.8" stroke={fillColor} strokeWidth="1.5" fill="none" />
      {!active ? (
        /* Checkmark for completed steps */
        <path
          d="M11 16.5L14.5 20L21 13"
          stroke={fillColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      ) : (
        /* Filled circle for active step */
        <circle cx="16" cy="16" r="5" fill={fillColor} />
      )}
    </svg>
  );
};

export default CheckCircleIcon;
